// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 32 ? "webfontloader" : chunkId) + "." + {"8":"10cfbb05","32":"594644b5","336":"94add20b","832":"bd204a71"}[chunkId] + ".js";
};